const typographyKeyVariants = {
  paragraphS: "paragraph-s",
  paragraphSBold: "paragraph-s paragraph-s--bold",
  paragraphM: "paragraph-m",
  paragraphMLink: "paragraph-m paragraph-m--link",
  paragraphMBold: "paragraph-m paragraph-m--bold",
  paragraphL: "paragraph-l",
  paragraphLBold: "paragraph-l--bold",
  paragraphLLink: "paragraph-l--link",
  headingXS: "heading-xs",
  headingXSBold: "heading-xs heading-xs--bold",
  headingS: "heading-s",
  headingSbold: "heading-s heading-s--bold",
  headingM: "heading-m",
  headingMBold: "heading-m heading-m--bold",
  headingL: "heading-l",
  headingXL: "heading-xl",
  ctaButtonText: "cta__button-text",
  ctaButtonLink: "cta__button-link",
  labelS: "label-s",
  labelSBold: "label-s label-s--bold",
  labelSLink: "label-s label-s--link",
  labelM: "label-m",
  labelMBold: "label-m--bold",
  labelMLink: "label-m--link",
  inputTextArea: "input__text-area",
  inputLabel: "input__label",
  inputInfo: "input__info",
} as const

type TTypographyVariantKeys = keyof typeof typographyKeyVariants

function getClassTypographyVariant(
  variant: keyof typeof typographyKeyVariants
): string {
  return typographyKeyVariants[variant]
}

export { type TTypographyVariantKeys, getClassTypographyVariant }
